import { Card, Col, Row } from 'antd';
import { dashboardBoxes } from './dashboardBoxes';
import { useNavigate } from 'react-router-dom';

export default function SuperAdminDashboard() {
  const navigate = useNavigate();
  return (
    <div style={{ padding: '20px' }}>
      <Row gutter={[16, 16]} justify="center">
        {dashboardBoxes.map((box) => (
          <Col xs={24} sm={12} md={8} lg={8} key={box.key}>
            <Card
              hoverable
              onClick={() => navigate(box.route)}
              style={{
                textAlign: 'center',
                background: box.color,
                borderColor: box.borderColor,
                height: '150px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              {box.icon}
              <h3 style={{ margin: '10px 0', color: '#333' }}>{box.title}</h3>
              <p style={{ fontSize: '14px', color: '#555' }}>
                {box.description}
              </p>
            </Card>
          </Col>
        ))}
      </Row>
      {/* 
      <GlobalFormModal isVisible={isModalVisible} onClose={handleCloseModal}>
        {renderModalComponent()}
      </GlobalFormModal> */}
    </div>
  );
}
